var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyVitals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11201 6.68798L32.096 6.75198C32.096 6.75198 34.296 6.31198 34.36 8.57598C34.424 10.84 34.36 25.088 34.36 25.088C34.36 25.088 34.864 27.6 32.288 27.6C29.712 27.6 8.04801 27.6 8.04801 27.6C8.04801 27.6 5.84801 28.04 5.91201 25.088C5.97601 22.136 5.91201 8.57598 5.91201 8.57598C5.91201 8.57598 6.04001 6.55998 8.11201 6.68798Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.392 16.416H18.032L19.232 15.04L20.608 20.688L21.928 12.84L24.064 17.608L25.256 16.352L26.32 16.232",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.816 19.304L28.864 22.888",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2159 20.624L27.2639 22.84",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.568 21.704L25.616 22.888",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8561 27.592L29.9041 29.432C29.9041 29.432 30.1361 30.376 28.5841 30.472C27.0321 30.568 12.0081 30.472 12.0081 30.472C12.0081 30.472 10.7841 30.616 10.7841 29.248C10.7841 27.88 10.7841 27.648 10.7841 27.648",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9279 30.544L21.9919 34.248C21.9919 34.248 22.2399 35.504 20.6079 35.376C18.9759 35.248 18.7839 35.408 18.7439 33.856C18.7039 32.304 18.6479 30.512 18.6479 30.512",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.96 10.032H28.584C28.584 10.032 30.848 9.752 30.848 11.96C30.848 14.168 30.8 21.328 30.8 21.328C30.8 21.328 31.272 23.824 28.96 23.776C26.656 23.728 12.192 23.776 12.192 23.776C12.192 23.776 9.88799 23.824 9.83999 21.608C9.79199 19.392 9.79199 11.768 9.79199 11.768C9.79199 11.768 9.93599 9.84 11.96 10.032Z",
    stroke: "#A977F9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyVitals);
export default __webpack_public_path__ + "static/media/BodyVitals.b5bf7f6a706e3ac8b03f51734a4802fa.svg";
export { ForwardRef as ReactComponent };